import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Activity } from "lucide-react";

/* Gate for the admin area. Backend also enforces role on every /api/admin route. */
export function RequireAdmin({ children }) {
  const { user, authReady } = useAuth();

  if (!authReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F7F9]" data-testid="admin-loading">
        <div className="flex items-center gap-2 text-slate-400 text-sm">
          <Activity className="w-4 h-4 animate-pulse" /> Loading…
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: "/admin" }} />;
  if (user.role !== "admin") return <Navigate to="/sections" replace />;
  return children;
}

export default RequireAdmin;
